import ChkIcon from '../../../../../resources/common/chk.svg';
import ChkOnIcon from '../../../../../resources/common/chk_on.svg';

const CommonStyle = `
  .jw-state-idle .jw-controls {
    background: rgba(0, 0, 0, 0) !important;
  }
  body{overflow:auto !important}
  html,
    body {
      height:100%;
      position: relative;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      vertical-align: baseline;
    }
    .swiper-pagination {
      position: absolute;
      text-align: center;
      transition: 300ms opacity;
      transform: translate3d(0, 0, 0);
      z-index: 10;
    }
    .swiper-container-horizontal
      > .swiper-pagination-bullets
      .swiper-pagination-bullet {
      margin: 0 4px;
    }
    .swiper-pagination-clickable .swiper-pagination-bullet {
      cursor: pointer;
    }
    .swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      display: inline-block;
      border-radius: 50%;
      background: #000;
      opacity: 0.2;
    }
    .content-area {
      height:100%;
      box-sizing: border-box;
      margin-bottom:100px;
    }
    .livebtn {
      position: relative;
      display: inline-block;
      width: 57px;
      height: 24px;
      text-align: center;
      background: #fff;
      border: 1px solid #723ec6;
      border-radius: 12px;
      box-sizing: border-box;
      margin-right:6px;

    }
    .livebtn small {
      display: inline-block;
      width: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: inline-block;
      color: #723ec6;
      font-size: 12px;
      font-weight: 400;
    }
    
    .ondemandbtn {
      position: relative;
      display: inline-block;
      width: 96px;
      text-align: center;
      color: #94ad51;
      font-size: 12px;
      height: 24px;
      line-height: 24px;
      background: #fff;
      border: 1px solid #94ad51;
      border-radius: 12px;
      box-sizing: border-box;
      margin-right:6px;
    }
    .ondemandbtn small {
      display: inline-block;
      width: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: inline-block;
      color: #94ad51;
      font-size: 10px;
      line-height: 1.6;
      font-weight: 400;
    }
    .basic_btn {
      width: 160px;
      height: 60px;
      line-height: 60px;
      background: #6a6af8;
      border-radius: 4px;
      color: #fff;
      font-size: 15px;
    }
  /*============어드민페이지===========*/
    /*====양쪽 사이드바====*/
    
    .admin_console {
      position: absolute;
      top: 250px;
      background: #3e3e46;
      box-sizing: border-box;
      box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
      transition: all 0.3s;
      z-index: 999;
    }
    .left_console {
      width: 300px;
      left: 0;
      border-radius: 0;
      height: 620px;
      overflow: hidden;
    }
    .right_console {
      width: 260px;
      right: 0;
      border-radius: 8px 0 0 8px;
      height: 220px;
      overflow: hidden;
    }
    
    /*=====lest_console========*/
    .left_console.on .text_container_top,
    .left_console.on .text_container_content {
      display: none;
    }
    .left_console .left_console_folding {
      display: none;
    }
    .left_console.on .left_console_folding {
      display: block;
    }
    .left_console.on {
      width: 42px;
      height: 220px;
      padding: 0;
    }
    .left_console.on .left_console_folding button {
      position: relative;
      display: block;
      width: 42px;
      height: 220px;
    }
    .left_console.on .left_console_folding button .arrow_div{
      position: absolute;
      top: 0;
      left: 0;
      width: 42px;
      height: 42px;
      text-align: center;
    }
    .left_console.on .left_console_folding button .number_div{
      height: calc(100% - 42px);
      width: 42px;
      margin-top: 42px;
    }
    .left_console.on .left_console_folding button img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%) rotate(180deg);
      width: 12px;
      height: 12px;
      opacity: 0.78;
    }
    .left_console.on .left_console_folding h2 {
      display: inline-block;
      font-size: 13px;
      font-weight: 400;
      color: #fff;
      width: 100%;
      height: auto;
      position: absolute;
      top: 50%;
      left:0;
      transform: rotate(-90deg);
      white-space:nowrap;
    }
    
    
    .text_container_top {
      position: relative;
      display:flex;
      background: #33343d;
      height: 50px;
      text-align: center;
    }
    .text_container_top:after {
      content: "";
      clear: both;
      display: block;
    }
    .text_container_top h2 {
      float: left;
      width: calc(100% - 42px);
      margin: 0px;
      font-size: 13px;
      color: #fff;
      line-height: 50px;
      font-weight: 400;
    }
    #firstB {
      position: relative;
      float: left;
      width: 42px;
      height: 50px;
      line-height: 50px;
      cursor: pointer;
      background: #3e3e46;
      border: 0;
      outline: none;
      padding: 0;
      appearance: none;
    }
    #firstB img,
    #prevB img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 11px;
      height: 11px;
      opacity: 0.78;
    }
    #prevB {
      position: absolute;
      top: 13px;
      right: 18px;
      left: auto;
      width: 24px;
      height: 24px;
      line-height: 24px;
      cursor: pointer;
      background: rgba(255, 255, 255, 0.04);
      border: 1px solid rgba(255, 255, 255, 0.1);
      border-radius: 8px;
      outline: none;
      padding: 0;
      appearance: none;
      z-index: 2;
    }
    #prevB img {
      top: 50%;
      width: 9px;
      height: 9px;
    }
    #prevB:hover {
      background: rgba(255, 255, 255, 0.08);
      border-color: rgba(255, 255, 255, 0.14);
    }
    #prevB:focus-visible {
      border-color: rgba(255, 255, 255, 0.2);
    }
    .text_container_content{
      position:relative;
      height: calc(100% - 50px);
    }
    .text_container_content:after {
      content: "";
      clear: both;
      display: block;
    }
    .control_fix_div{
      position: absolute;
      bottom: 0;
      right: 0;
      padding: 14px;
      border-top: 1px solid #1f1f24;
      width: 100%;
      text-align: right;
    }
    .control_fix_div input{display:none;}
    .control_fix_div label{
      color: #fff;
      font-size: 12px;
      font-weight: 500;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
    .control_fix_div input + label span{
      display: inline-block;
      width: 18px;
      height: 18px;
      margin-right: 4px;
      box-sizing: border-box;
      background: url(${ChkIcon}) no-repeat;
      background-size:cover;
    }
    .control_fix_div input:checked + label span{
      background: url(${ChkOnIcon}) no-repeat;
      background-size:cover;
    }
    .control_list li {border-bottom:0 !important;}
    .control_list li img{opacity:0.3;}
    .control_list li.on img{opacity:1;}
    .control_list li.on a {
      background: transparent;
    }

    
    .control_list li.on a img {
      opacity: 1;
    }
    
    .control_list a {
      display: flex;
      align-items: center;
      height: 44px;
      line-height: 44px;
      text-align: center;
      color: #fff !important;
      background: transparent;
      padding: 10px 12px;
      box-sizing: border-box;
      cursor: pointer;
    }
    .control_list a img {
      width: 14px;
      height: 14px;
      object-fit: contain;
      flex: 0 0 14px;
      display: block;
    }
    .control_list a svg {
      width: 14px !important;
      height: 14px !important;
      flex: 0 0 14px;
      display: block;
    }
    .control_list a span {
      font-size: 13px;
      font-weight: 400;
      display: inline-block;
      margin-left: 26px;
    }
    .control_list a.selected {
      background: transparent;
    }
    .control_list a.selected img {
      opacity: 1;
    }
    .control_list.on {
      float: left;
      width: 42px;
    }
    .control_list.on a {
      justify-content: center;
      padding: 0;
    }
    .control_list.on a img {
      margin: 0 auto;
    }
    .control_list.on span {
      display: none;
    }
    .control_list.on .control_list li:last-child {
      border-bottom: 0;
    }
    
    .control_content {
      position: relative;
      float: left;
      width: calc(100% - 42px);
      background: #33343d;
      height: 100%;
      padding:10px;
    }
    .control_content.none {
      display: none;
    }
    .control_content .top_title{margin-bottom:6px;}
    .control_content .top_title span {
      font-size: 12px;
      padding: 5px 0px 0px 10px;
      display: block;
      color: #5e5e61;
    }

    .control_content_list{margin-bottom:15px;}
    .control_content_list li{
      border-radius: 0;
      padding: 10px;
      background:#33343d;
      margin-bottom:6px;
    }
    .control_content_list li:last-child{
      margin-bottom:0;
    }
    .control_content_list a{display:block; margin-bottom:14px; cursor:pointer;}
    .control_content_list a span {
      font-size: 12px;
      color: #fff;
      line-height: 1.43;
      display:-webkit-box;
      -webkit-line-clamp:2;
      -webkit-box-orient:vertical;
      overflow:hidden;
    }
    .control_content_list .control_content_list_tool{display:flex; justify-content:flex-end; align-items:center;}
    .control_content_list .control_content_list_tool > div {display:flex; align-items:center;}
    .control_content_list .control_content_list_tool > div span{
      display:block;
      font-size: 11px;
      font-weight: 500;
      line-height: 11px;
      color: #5e5e61;
      margin-right:4px;
    }
    .control_content_list .control_content_list_tool label.switch{margin-right:10px;}
    /* 토글 체크박스 */
    label.switch {
        position: relative;
        width: 34px;
        height: 18px;
        border-radius: 14px;
        background: #202026;
        cursor: pointer;
    }
    label.switch input[type='checkbox'] {
        display:none;}
    label.switch span {
        position: relative;
        width: 100%;
        height: 100%;
        display: inline-block;
    }
    label.switch span::before {
        content: '';
        position: absolute;
        display: block;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #999999;
        border-radius: 14px; }
        label.switch span::after {
        content: '';
        position: absolute;
        display: block;
        width: 12px;
        height: 12px;
        background-color: #fff;
        border-radius: 50%;
        top: 50%;
        left: 4px;
        transform:translateY(-50%);
        transition: left .3s ease;
        box-shadow: 0 2px 4px 0 rgb(90 90 90 / 50%);
    }
    label.switch input:checked ~ span::before {
        border: 1px solid #7758fa;
        background-color: #7758fa; }
    label.switch input:checked ~ span::after {
        left: 18px; }
    .control_content_list .control_content_list_tool .on_off_exporsure{cursor:auto;}
    .control_content_list .control_content_list_tool .on_off_exporsure strong{
      display: block;
      padding: 1px 10px;
      font-size: 8px;
      font-weight: bold;
      text-align: left;
      color: #7758fa;
      border-radius: 14px;
      border: solid 1px #7758fa;
    }
    .control_content_list .control_content_list_tool .on_off_exporsure strong.off{
      color: #5e5e61;
      border: solid 1px #5e5e61;
    }



    .control_content_detail {
      position: relative;
      float: left;
      width: calc(100% - 42px);
      background: #33343d;
      height: 100%;
      padding:10px;
      z-index: 999;
    }
    .control_content_detail > div{
      border-radius: 0;
      background-color: #33343d;
      margin-bottom:6px;
    }
    .control_content_detail > div:first-child{padding:10px;}
    .control_content_detail > div h4{
      font-size: 12px;
      line-height: 1.5;
      color: #fff;
      display:-webkit-box;
      -webkit-line-clamp:2;
      -webkit-box-orient:vertical;
      overflow:hidden;
    }
    .control_content_detail > div li {
      display:flex;
      align-items:center;
      justify-content:space-between;
      padding:10px;
      border-bottom: 1px solid #000;
    }

    .control_content_detail > div li:last-child {
      border-bottom: 0;
      cursor:pointer;
    }
    .control_content_detail > div li div{height:18px;}
    .control_content_detail > div li div a{
      display: block;
      width: 18px;
      height: 18px;
      text-align: center;
    }
    .control_content_detail > div li div span{
      font-size: 11px;
      font-weight: 500;
      line-height: 1.82;
      color: #fff;
    }
    .control_content_detail > div li h5{
      font-size: 12px;
      font-weight: 500;
      text-align: left;
      color: #5e5e61;
    }
    
    .control_content_detail .connect_way_div_inner{
      display:flex;
      justify-content:flex-end;
      align-items:center;
    }
    .control_content_detail .connect_way_div input {
      display: none;
    }
    .control_content_detail .connect_way_div input[type="radio"] + label span {
      display: inline-block;
      width: 18px;
      height: 18px;
      margin-right: 5px;
      box-sizing: border-box;
      background: url("https://cdn.onoffevent.com/common/form_radio_off.svg");
      cursor:pointer;
    }
    .control_content_detail .connect_way_div input[type="radio"]:checked + label span {
      background: url("https://cdn.onoffevent.com/common/form_radio_on.svg");
      cursor:pointer;
    }
    .control_content_detail .connect_way_div label {
      display: flex;
      align-items: center;
      font-size: 11px;
      color: #fff;
      margin-right: 10px;
    }
    .control_content_detail .connect_way_div label:last-child {
      margin-right: 0;
    }
    .control_content_detail .progress_complete input {
      display: none;
    }
    .control_content_detail .progress_complete input + label {
      display: flex;
      align-items: center;
      font-size: 11px;
      font-weight:500;
      color:#fff;
      cursor:pointer;
    }
    .control_content_detail .progress_complete input + label span {
      display: inline-block;
      width: 18px;
      height: 18px;
      margin-right: 4px;
      border-radius: 4px;
      box-sizing: border-box;
      background: url("${ChkIcon}") no-repeat;
      background-size:cover;
      cursor:pointer;
    }
    .control_content_detail .progress_complete input:checked + label span {
      background: url("${ChkOnIcon}") no-repeat;
      background-size:cover;
      cursor:pointer;
    }

    .control_content_detail > div li.survey_edit h5{
      font-size: 12px;
      font-weight: 500;
      color: #7758fa;
    }

    .streaming_content_list li.selected {
      border: 0;
      outline: 0;
    }
    .streaming_content_list li.disabled {
      opacity: 0.78;
      border: 1px dashed #3a3a42;
    }
    .streaming_content_list li.disabled a {
      cursor: default;
      margin-bottom: 0;
    }
    .streaming_channel_head {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 8px;
      margin-bottom: 10px;
    }
    .streaming_channel_main {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;
      flex: 1;
      min-width: 0;
    }
    .streaming_channel_title {
      display: flex;
      align-items: center;
      margin-bottom: 0 !important;
      flex: 1;
      width: 100%;
      cursor: pointer;
      min-width: 0;
    }
    .streaming_channel_title span,
    .streaming_channel_title_text {
      font-size: 12px;
      color: #fff;
      line-height: 1.4;
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      min-width: 0;
    }
    .streaming_channel_actions {
      display: flex;
      align-items: flex-start;
      flex-shrink: 0;
    }
    .streaming_info_button {
      border: 0;
      padding: 0;
      margin: 0;
      background: transparent;
      color: #9ca3af;
      font-size: 10px;
      line-height: 1;
      cursor: pointer;
      flex-shrink: 0;
    }
    .streaming_info_button:hover {
      color: #d1d5db;
    }
    .streaming_channel_switch {
      margin-right: 0 !important;
    }
    .streaming_channel_switch input:disabled ~ span {
      cursor: not-allowed;
    }
    .streaming_channel_switch input:disabled ~ span::before {
      background-color: #3b3b40;
      border: 1px solid #4b4b52;
    }
    .streaming_channel_switch input:disabled ~ span::after {
      background-color: #7d7d87;
    }
    .streaming_content_list li.disabled .streaming_info_button {
      color: #7d7d87;
    }
    .streaming_content_list li.disabled .streaming_channel_title_text {
      cursor: default;
    }
    .streaming_top_action {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
      margin-bottom: 16px;
    }
    .streaming_top_action .streaming_all_channels_text_button {
      margin-left: auto;
      margin-right: 8px;
    }
    .streaming_content_list li {
      padding-top: 12px;
      padding-bottom: 12px;
      padding-left: 10px;
      padding-right: 8px;
    }
    .streaming_card_status_row {
      margin-bottom: 8px;
      display: flex;
      align-items: center;
    }
    .streaming_card_status_badge {
      margin-left: 0 !important;
      min-width: 46px !important;
      height: 15px;
      padding: 0 3px !important;
      font-size: 9px;
      font-weight: 500;
      border-radius: 4px;
      text-transform: uppercase;
      align-self: flex-start;
    }
    .streaming_all_channels_text_button {
      border: 0;
      padding: 0;
      margin: 0;
      background: transparent;
      color: #9ca3af;
      font-size: 10px;
      line-height: 1;
      cursor: pointer;
    }
    .streaming_all_channels_text_button:hover {
      color: #d1d5db;
    }
    .streaming_channel_bottom_row {
      justify-content: space-between !important;
      align-items: center;
      margin-top: 6px;
    }
    .streaming_channel_bottom_row .streaming_channel_id_text,
    .streaming_channel_bottom_row .streaming_info_button {
      color: #8b8b90;
      font-size: 11px;
      line-height: 1.2;
      font-weight: 400;
    }
    .streaming_channel_bottom_row .streaming_info_button {
      border: 0;
      background: transparent;
      padding: 0;
      margin: 0;
      cursor: pointer;
    }
    .streaming_channel_bottom_row .streaming_info_button:hover {
      color: #8b8b90;
    }
    .streaming_channel_bottom_row > div span {
      margin-right: 0 !important;
    }
    .streaming_content_list li.streaming_empty_item {
      text-align: center;
      padding: 16px 8px;
      color: #8b8b90;
      font-size: 12px;
    }
    .streaming_content_list li.streaming_empty_item span {
      margin: 0;
      color: #8b8b90;
    }
    .streaming_status_badge {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-width: 56px;
      height: 20px;
      padding: 0 8px;
      border-radius: 4px;
      font-size: 10px;
      font-weight: 600;
      line-height: 1;
      color: #d1d5db;
      background: #3b3b40;
      margin-left: 8px;
      white-space: nowrap;
    }
    .streaming_status_badge.status_ready {
      color: #22c55e;
      border: 1px solid #22c55e;
      background: rgba(34, 197, 94, 0.15);
    }
    .streaming_status_badge.status_reserved {
      color: #60a5fa;
      border: 1px solid #60a5fa;
      background: rgba(96, 165, 250, 0.15);
    }
    .streaming_status_badge.status_live {
      color: #f87171;
      border: 1px solid #f87171;
      background: rgba(248, 113, 113, 0.15);
    }
    .streaming_status_badge.status_suspended {
      color: #f59e0b;
      border: 1px solid #f59e0b;
      background: rgba(245, 158, 11, 0.15);
    }
    .streaming_status_badge.status_ended {
      color: #a1a1aa;
      border: 1px solid #a1a1aa;
      background: rgba(161, 161, 170, 0.15);
    }
    .streaming_channel_meta {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 4px;
      align-items: flex-end;
    }
    .streaming_channel_meta span {
      margin: 0;
      color: #8b8b90 !important;
      font-size: 10px;
      line-height: 1.3;
    }
    .streaming_help_box {
      border: 1px solid #1f1f24;
      background: #33343d;
      border-radius: 0;
      padding: 10px;
    }
    .streaming_help_box p {
      font-size: 11px;
      color: #8b8b90;
      line-height: 1.4;
      margin: 0 0 8px 0;
    }
    .streaming_help_box button {
      width: 100%;
      height: 30px;
      border-radius: 0;
      border: 0;
      background: #5959ef;
      color: #fff;
      font-size: 12px;
      font-weight: 500;
      cursor: pointer;
    }
    .streaming_selected_title p {
      margin-top: 6px;
      font-size: 11px;
      color: #8b8b90;
    }
    .streaming_detail_panel .streaming_selected_title {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;
      padding: 2px 0 10px;
      background: transparent;
      margin-bottom: 8px;
    }
    .control_content_detail.streaming_detail_panel {
      padding-left: 20px;
      padding-right: 18px;
    }
    .streaming_selected_title_tools {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
    .streaming_detail_back_button {
      width: auto;
      height: 20px;
      border: 0;
      background: transparent;
      padding: 0;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      justify-content: flex-start;
      gap: 4px;
    }
    .streaming_detail_back_button img {
      width: 10px;
      height: 10px;
      opacity: 0.9;
      display: block;
    }
    .streaming_detail_back_button span {
      color: #aeb4c5;
      font-size: 10px;
      line-height: 1;
      font-weight: 400;
      white-space: nowrap;
    }
    .streaming_detail_back_button:hover img {
      opacity: 1;
    }
    .streaming_detail_back_button:hover span {
      color: #d8ddee;
    }
    .streaming_detail_info_button {
      border: 0;
      background: transparent;
      padding: 0;
      margin: 0;
      margin-left: auto;
      color: #a7acbb;
      font-size: 11px;
      line-height: 1;
      font-weight: 400;
      cursor: pointer;
      white-space: nowrap;
      text-align: right;
    }
    .streaming_detail_info_button:hover {
      color: #d7dbea;
    }
    .streaming_detail_panel > .streaming_selected_title:first-child {
      padding-left: 0;
      padding-right: 0;
    }
    .streaming_detail_panel .streaming_selected_title h4 {
      margin: 0;
      font-size: 13px;
      line-height: 1.35;
      color: #ffffff;
      word-break: break-all;
      font-weight: 500;
    }
    .streaming_detail_panel .streaming_selected_title p {
      margin: 0;
      color: #8f93a1;
    }
    .streaming_panel_test_actions {
      display: flex;
      align-items: center;
      gap: 10px;
      margin: 8px 0 48px;
      padding: 8px 0;
      margin-left: -8px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    }
    .streaming_panel_test_label {
      display: inline-flex;
      align-items: center;
      color: #f3f4f6;
      font-size: 12px;
      line-height: 1;
      font-weight: 500;
      flex-shrink: 0;
      width: 68px;
    }
    .streaming_panel_test_switch {
      margin-right: 0 !important;
      flex-shrink: 0;
    }
    .streaming_panel_test_switch input:disabled ~ span::before {
      background-color: #3b3b40;
      border: 1px solid #4b4b52;
    }
    .streaming_panel_test_switch input:disabled ~ span::after {
      background-color: #7d7d87;
    }
    .streaming_panel_test_text {
      display: inline-flex;
      align-items: center;
      color: #9aa0b3;
      font-size: 11px;
      line-height: 1;
      font-weight: 500;
      margin-left: -2px;
    }
    .streaming_panel_test_text.active {
      color: #f3f4f6;
    }
    .streaming_detail_panel .streaming_detail_list {
      margin: 0;
      padding: 0;
      list-style: none;
    }
    .streaming_detail_panel .streaming_detail_list li {
      display: block !important;
      align-items: initial !important;
      justify-content: initial !important;
      gap: 0 !important;
      padding: 8px 0 !important;
      border-bottom: 0 !important;
    }
    .streaming_detail_panel .streaming_detail_list li + li {
      margin-top: 8px;
    }
    .streaming_detail_panel .streaming_detail_list li:last-child {
      cursor: default !important;
    }
    .streaming_detail_panel .streaming_detail_list li h5 {
      margin: 0;
      font-size: 11px;
      line-height: 1.3;
      color: #9aa0b3 !important;
      font-weight: 400 !important;
    }
    .streaming_detail_panel .streaming_detail_list li div {
      margin-top: 4px;
      text-align: left !important;
      height: auto !important;
    }
    .streaming_detail_panel .streaming_detail_list li div span {
      margin: 0;
      display: inline-block;
      max-width: 100%;
      font-size: 12px;
      line-height: 1.35;
      color: #f3f4f6 !important;
      font-weight: 400 !important;
      word-break: break-all;
    }
    .streaming_detail_panel .streaming_detail_list li .streaming_value_with_copy {
      position: static;
      display: inline;
      max-width: none;
      padding-right: 0;
    }
    .streaming_detail_panel .streaming_detail_list li .streaming_value_with_copy span {
      display: inline;
      max-width: none;
    }
    .streaming_inline_copy_button {
      width: 14px;
      height: 14px;
      border: 0;
      background: transparent;
      padding: 0;
      margin-top: 0;
      margin-left: 4px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      flex-shrink: 0;
      position: static;
      vertical-align: baseline;
    }
    .streaming_inline_copy_button img {
      width: 12px;
      height: 12px;
      opacity: 0.95;
      filter: brightness(0) invert(1);
      display: block;
    }
    .streaming_inline_copy_button:hover img {
      opacity: 1;
    }
    .streaming_inline_copy_done {
      font-size: 11px;
      line-height: 1;
      color: #22c55e;
      font-weight: 700;
    }
    .streaming_detail_actions {
      border-top: 0;
      padding: 8px 0 4px;
    }
    .streaming_detail_action_button {
      width: 100%;
      border: 0;
      background: transparent;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 12px;
      cursor: pointer;
    }
    .streaming_detail_action_button span {
      color: #b8bdca;
      font-size: 11px;
      line-height: 1.2;
      font-weight: 400;
    }
    .streaming_detail_action_button img {
      width: 11px;
      height: 11px;
      opacity: 0.7;
    }
    .streaming_detail_action_button:hover span {
      color: #e5e7eb;
    }
    .streaming_detail_action_button:hover img {
      opacity: 0.9;
    }
    .streaming_empty_state {
      padding: 16px;
      font-size: 12px;
      color: #8b8b90;
      text-align: center;
    }

    #consoleStreamingToggleOffConfirmModal,
    #consoleStreamingToggleSwitchConfirmModal {
      z-index: 1110;
      position: fixed;
      inset: 0;
      background: rgba(0, 0, 0, 0.52);
      overflow: hidden;
    }
    #consoleStreamingToggleOffConfirmModal .modal-dialog,
    #consoleStreamingToggleSwitchConfirmModal .modal-dialog {
      position: fixed !important;
      top: 120px !important;
      left: 50% !important;
      transform: translateX(-50%) !important;
      width: 480px !important;
      max-width: 90vw !important;
      margin: 0 !important;
    }
    #consoleStreamingToggleOffConfirmModal .modal-content,
    #consoleStreamingToggleSwitchConfirmModal .modal-content {
      border: 1px solid #e5e7eb;
      border-radius: 12px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }
    #consoleStreamingToggleOffConfirmModal .modal-base .modal-header,
    #consoleStreamingToggleSwitchConfirmModal .modal-base .modal-header {
      border-bottom: 0;
      padding: 18px 20px 14px;
    }
    #consoleStreamingToggleOffConfirmModal .modal-base-head-row,
    #consoleStreamingToggleSwitchConfirmModal .modal-base-head-row {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      width: 100%;
    }
    #consoleStreamingToggleOffConfirmModal .modal-base-head-copy,
    #consoleStreamingToggleSwitchConfirmModal .modal-base-head-copy {
      min-width: 0;
      flex: 1;
    }
    #consoleStreamingToggleOffConfirmModal .modal-base-close,
    #consoleStreamingToggleSwitchConfirmModal .modal-base-close {
      width: 36px;
      height: 36px;
      flex-shrink: 0;
    }
    #consoleStreamingToggleOffConfirmModal .modal-footer,
    #consoleStreamingToggleSwitchConfirmModal .modal-footer {
      border-top: 0;
      padding: 10px 20px 20px;
      background: #fff;
    }
    #consoleStreamingToggleOffConfirmModal .modal-base-footer,
    #consoleStreamingToggleSwitchConfirmModal .modal-base-footer {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 8px;
      width: 100%;
    }

    #consoleStreamingChannelDetailModal {
      z-index: 1110;
      position: fixed;
      inset: 0;
      background: rgba(0, 0, 0, 0.52);
      overflow: hidden;
    }
    #consoleStreamingChannelDetailModal .modal-dialog {
      position: fixed !important;
      top: 120px !important;
      left: 50% !important;
      transform: translateX(-50%) !important;
      max-width: 960px;
      width: calc(100% - 40px);
      margin: 0 !important;
    }
    #consoleStreamingChannelDetailModal .modal-content {
      border: 1px solid #e5e7eb;
      border-radius: 12px;
      overflow: hidden;
      background: #fff;
      max-height: calc(100vh - 140px);
      display: flex;
      flex-direction: column;
    }
    #consoleStreamingChannelDetailModal .modal-base .modal-header {
      border-bottom: 0;
      padding: 18px 20px 14px;
    }
    #consoleStreamingChannelDetailModal .modal-base-head-row {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 12px;
      width: 100%;
    }
    #consoleStreamingChannelDetailModal .modal-base-head-copy {
      min-width: 0;
      flex: 1;
    }
    #consoleStreamingChannelDetailModal .modal-base .MuiTypography-modaltitle {
      margin: 0;
      font-size: 22px !important;
      line-height: 1.2;
      color: #111827;
      font-weight: 700;
    }
    #consoleStreamingChannelDetailModal .modal-base .modal-base-subtitle {
      margin-top: 4px;
      color: #64748b;
      opacity: 0.7;
      font-size: 12px;
      line-height: 1.4;
    }
    #consoleStreamingChannelDetailModal .modal-base-close {
      width: 36px;
      height: 36px;
      border: 0;
      border-radius: 6px;
      background: #fff;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }
    #consoleStreamingChannelDetailModal .modal-body {
      padding: 16px 20px 12px;
      max-height: calc(100vh - 240px);
      overflow-y: auto;
      background: #fff;
      flex: 1 1 auto;
    }
    #consoleStreamingChannelDetailModal .modal-footer {
      border-top: 0;
      padding: 10px 20px 20px;
      background: #fff;
    }
    #consoleStreamingChannelDetailModal .modal-base-footer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
    }
    #consoleStreamingChannelDetailModal .modal-base-footer-left {
      flex: 1;
    }
    #consoleStreamingAllChannelsModal {
      z-index: 1110;
      position: fixed;
      inset: 0;
      background: rgba(0, 0, 0, 0.52);
      overflow: hidden;
    }
    #consoleStreamingAllChannelsModal .modal-dialog {
      position: fixed !important;
      top: 120px !important;
      left: 50% !important;
      transform: translateX(-50%) !important;
      max-width: 980px;
      width: calc(100% - 40px);
      margin: 0 !important;
    }
    #consoleStreamingAllChannelsModal .modal-content {
      border: 1px solid #e5e7eb;
      border-radius: 12px;
      overflow: hidden;
      background: #fff;
      max-height: calc(100vh - 140px);
      display: flex;
      flex-direction: column;
    }
    #consoleStreamingAllChannelsModal .modal-base .modal-header {
      border-bottom: 0;
      padding: 18px 20px 14px;
    }
    #consoleStreamingAllChannelsModal .modal-base-head-row {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 12px;
      width: 100%;
    }
    #consoleStreamingAllChannelsModal .modal-base-head-copy {
      min-width: 0;
      flex: 1;
    }
    #consoleStreamingAllChannelsModal .modal-base .MuiTypography-modaltitle {
      margin: 0;
      font-size: 22px !important;
      line-height: 1.2;
      color: #111827;
      font-weight: 700;
    }
    #consoleStreamingAllChannelsModal .modal-base .modal-base-subtitle {
      margin-top: 4px;
      color: #64748b;
      opacity: 0.7;
      font-size: 12px;
      line-height: 1.4;
    }
    #consoleStreamingAllChannelsModal .modal-base-close {
      width: 36px;
      height: 36px;
      border: 0;
      border-radius: 6px;
      background: #fff;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }
    #consoleStreamingAllChannelsModal .modal-body {
      padding: 16px 20px 12px;
      max-height: calc(100vh - 240px);
      overflow-y: auto;
      background: #fff;
      flex: 1 1 auto;
    }
    #consoleStreamingAllChannelsModal .modal-footer {
      border-top: 0;
      padding: 10px 20px 20px;
      background: #fff;
    }
    #consoleStreamingAllChannelsModal .modal-base-footer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
    }
    #consoleStreamingAllChannelsModal .modal-base-footer-left {
      flex: 1;
    }
    .streaming_all_channels_modal_body {
      width: 100%;
      border: 1px solid #eaeaea;
      border-radius: 6px;
      overflow: hidden;
      background: #fff;
    }
    .streaming_all_channels_toolbar {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      gap: 12px;
      padding: 12px;
      background: #fff;
      border-bottom: 1px solid #efefef;
    }
    .streaming_all_channels_toolbar_left,
    .streaming_all_channels_toolbar_right {
      display: flex;
      align-items: center;
    }
    .streaming_all_channels_filter_select {
      height: 32px;
      min-width: 126px;
      border: 1px solid #d7d7d7;
      border-radius: 6px;
      background: #fff;
      color: #464f60;
      font-size: 13px;
      padding: 0 10px;
      outline: none;
      cursor: pointer;
    }
    .streaming_all_channels_search_wrap {
      width: 220px;
      height: 32px;
      border: 1px solid #d7d7d7;
      border-radius: 6px;
      background: #fff;
      display: inline-flex;
      align-items: center;
      padding: 0 10px;
      gap: 6px;
      box-sizing: border-box;
    }
    .streaming_all_channels_search_wrap .MuiSvgIcon-root {
      width: 16px;
      height: 16px;
      color: #64748b;
      flex-shrink: 0;
    }
    .streaming_all_channels_search_wrap input {
      width: 100%;
      border: 0;
      outline: none;
      background: transparent;
      color: #464f60;
      font-size: 13px;
      line-height: 1;
    }
    .streaming_all_channels_search_wrap input::placeholder {
      color: #b7b7bd;
    }
    .streaming_all_channels_table {
      width: 100%;
      border-collapse: collapse;
      background: #fff;
    }
    .streaming_all_channels_table th,
    .streaming_all_channels_table td {
      border-bottom: 1px solid #e5e7eb;
      padding: 8px 10px;
      font-size: 12px;
      color: #475569;
      text-align: left;
      vertical-align: middle;
      white-space: nowrap;
    }
    .streaming_all_channels_table th {
      background: #f8fafc;
      color: #64748b;
      font-weight: 600;
    }
    .streaming_all_channels_table td:nth-child(2) {
      max-width: 280px;
      white-space: normal;
      word-break: break-all;
    }
    .streaming_all_channel_name_cell {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;
    }
    .streaming_all_channel_name_button {
      border: 0;
      background: transparent;
      margin: 0;
      padding: 0;
      color: #475569;
      font-size: 12px;
      line-height: 1.45;
      text-align: left;
      cursor: pointer;
    }
    .streaming_all_channel_name_button:hover {
      color: #334155;
      text-decoration: underline;
    }
    .streaming_all_channel_console_link {
      color: #667085;
      font-size: 11px;
      line-height: 1.25;
      text-decoration: none;
      cursor: pointer;
    }
    .streaming_all_channel_console_link:hover {
      color: #475467;
      text-decoration: underline;
    }
    .streaming_all_channel_console_link.is-empty {
      pointer-events: none;
      text-decoration: none;
    }
    .streaming_all_channels_table td:nth-child(5) {
      max-width: 180px;
      white-space: normal;
      word-break: break-all;
    }
    .streaming_all_channels_table td:nth-child(6) {
      max-width: 160px;
      white-space: normal;
      word-break: break-all;
    }
    .streaming_all_channel_session_cell {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 2px;
    }
    .streaming_all_channel_session_name {
      color: #475569;
      font-size: 12px;
      line-height: 1.35;
    }
    .streaming_all_channel_session_datetime {
      color: #94a3b8;
      font-size: 11px;
      line-height: 1.25;
    }
    .streaming_all_channels_table td:last-child {
      width: 72px;
      text-align: center;
    }
    .streaming_all_channels_table tbody tr:nth-child(2n) td {
      background: #fafbfc;
    }
    .streaming_all_channels_table tbody tr:last-child td {
      border-bottom: 0;
    }
    .streaming_table_status_with_dot {
      display: flex;
      align-items: center;
      gap: 8px;
      line-height: 1;
    }
    .streaming_table_status_with_dot .status-dot {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      display: inline-block;
      flex-shrink: 0;
    }
    .streaming_table_status_with_dot span:last-child {
      color: #464f60;
      font-size: 12px;
      line-height: 1;
      font-weight: 400;
      letter-spacing: 0.01em;
    }
    .streaming_all_channel_action_icon_button {
      border: 0;
      background: transparent;
      margin: 0;
      padding: 0;
      width: 20px;
      height: 20px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      color: #6b7280;
      cursor: pointer;
    }
    .streaming_all_channel_action_icon_button .MuiSvgIcon-root {
      width: 20px;
      height: 20px;
    }
    .streaming_all_channel_action_icon_button:hover {
      color: #374151;
    }
    .streaming_all_channel_readonly {
      color: #94a3b8;
      font-size: 11px;
      line-height: 1;
      white-space: nowrap;
    }
    .streaming_all_channels_empty_row {
      text-align: center !important;
      color: #94a3b8 !important;
      padding: 24px 10px !important;
      background: #fff !important;
    }
    #consoleStreamingReserveConfirmModal {
      z-index: 1112;
      position: fixed;
      inset: 0;
      background: rgba(0, 0, 0, 0.52);
      overflow: hidden;
    }
    #consoleStreamingReserveConfirmModal .modal-dialog {
      position: fixed !important;
      top: 220px !important;
      left: 50% !important;
      transform: translateX(-50%) !important;
      max-width: 420px;
      width: calc(100% - 40px);
      margin: 0 !important;
    }
    #consoleStreamingReserveConfirmModal .modal-content {
      border: 1px solid #e5e7eb;
      border-radius: 12px;
      overflow: hidden;
      background: #fff;
    }
    #consoleStreamingReserveConfirmModal .modal-base .modal-header {
      border-bottom: 0;
      padding: 18px 20px 12px;
    }
    #consoleStreamingReserveConfirmModal .modal-base .MuiTypography-modaltitle {
      margin: 0;
      font-size: 20px !important;
      line-height: 1.2;
      color: #111827;
      font-weight: 700;
    }
    #consoleStreamingReserveConfirmModal .modal-base .modal-base-subtitle {
      margin-top: 4px;
      color: #64748b;
      opacity: 0.75;
      font-size: 12px;
      line-height: 1.4;
    }
    #consoleStreamingReserveConfirmModal .modal-base-close {
      width: 32px;
      height: 32px;
      border: 0;
      border-radius: 6px;
      background: #fff;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }
    #consoleStreamingReserveConfirmModal .modal-body {
      padding: 4px 20px 4px;
      background: #fff;
    }
    #consoleStreamingReserveConfirmModal .modal-footer {
      border-top: 0;
      padding: 10px 20px 20px;
      background: #fff;
    }
    .streaming_reserve_confirm_body p {
      margin: 0 0 6px;
      color: #475569;
      font-size: 13px;
      line-height: 1.4;
      word-break: break-all;
    }
    .streaming_reserve_confirm_body p:last-child {
      margin-bottom: 0;
    }
    .streaming_reserve_confirm_body p strong {
      display: inline-block;
      margin-right: 6px;
      color: #1f2937;
      font-weight: 600;
    }
    .streaming_reserve_confirm_actions {
      display: inline-flex;
      align-items: center;
      gap: 8px;
    }
    .streaming_modal2_confirm_button {
      min-width: 72px;
      height: 32px;
      border: 0;
      border-radius: 6px;
      padding: 0 14px;
      background: #5959ef;
      color: #fff;
      font-size: 13px;
      cursor: pointer;
    }
    .streaming_modal2_confirm_button:hover {
      background: #4d4de4;
    }
    .streaming_modal2_close_button {
      min-width: 52px;
      height: 32px;
      border: 0;
      border-radius: 6px;
      padding: 0 14px;
      background: #eef0ff;
      color: #4b5563;
      font-size: 13px;
      cursor: pointer;
    }
    .streaming_modal2_content {
      display: flex;
      flex-direction: column;
      gap: 14px;
    }
    .streaming_modal2_tabs {
      display: flex;
      align-items: center;
      gap: 16px;
      border-bottom: 1px solid #e5e7eb;
      padding-bottom: 8px;
    }
    .streaming_modal2_tab_button {
      border: 0;
      padding: 0 0 6px;
      margin: 0;
      background: transparent;
      color: #64748b;
      font-size: 13px;
      cursor: pointer;
      border-bottom: 2px solid transparent;
      font-weight: 500;
    }
    .streaming_modal2_tab_button.active {
      color: #1f2937;
      border-bottom-color: #1f2937;
      font-weight: 600;
    }
    .streaming_modal2_sections {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }
    .streaming_modal2_section_box {
      border: 1px solid #e5e7eb;
      padding: 16px;
      background: #fff;
    }
    .streaming_modal2_section_box h4 {
      margin: 0 0 12px 0;
      color: #5959ef;
      font-size: 14px;
      font-weight: 700;
      line-height: 1.2;
    }
    .streaming_modal2_grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 12px 20px;
    }
    .streaming_modal2_field {
      min-width: 0;
    }
    .media-center-field {
      margin-bottom: 12px;
    }
    .streaming_modal2_field h5 {
      margin: 0 0 8px 0;
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 13px;
      line-height: 1.3;
      font-weight: 400;
      color: #475569;
    }
    .streaming_modal2_value {
      margin: 0;
      font-size: 12px;
      line-height: 1.45;
      color: #b0b7c3;
      word-break: break-all;
    }
    .streaming_modal2_field p {
      margin: 0;
      font-size: 12px;
      line-height: 1.45;
      color: #b0b7c3;
      word-break: break-all;
    }
    .media-center-info-icon {
      width: 14px;
      height: 14px;
      border-radius: 50%;
      background: #4b5563;
      color: #fff;
      font-size: 10px;
      line-height: 14px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-weight: 600;
      cursor: default;
      flex-shrink: 0;
    }
    .streaming_modal2_value_with_action {
      display: flex;
      align-items: center;
      gap: 2px;
    }
    .streaming_modal2_value_with_action button,
    .streaming_copy_icon_button {
      border: 0;
      background: transparent;
      color: #6b7280;
      font-size: 11px;
      cursor: pointer;
      padding: 0;
      flex-shrink: 0;
    }
    .streaming_copy_icon_button img {
      width: 12px;
      height: 12px;
      opacity: 0.45;
      display: block;
    }
    .streaming_modal2_usage p {
      margin: 0 0 10px;
      font-size: 12px;
      color: #94a3b8;
    }
    .streaming_modal2_usage_table {
      width: 100%;
      border-collapse: collapse;
      border: 1px solid #e5e7eb;
      background: #fff;
    }
    .streaming_modal2_usage_table th,
    .streaming_modal2_usage_table td {
      border-bottom: 1px solid #e5e7eb;
      padding: 8px 10px;
      font-size: 12px;
      color: #475569;
      text-align: center;
    }
    .streaming_modal2_usage_table th {
      background: #f8fafc;
      color: #64748b;
      font-weight: 600;
    }
    .streaming_modal2_usage_table td.text-left {
      text-align: left;
    }
    .streaming_modal2_usage_table tbody tr:last-child td {
      border-bottom: 0;
    }
    .streaming_modal_dim {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.62);
      z-index: 1100;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 12px;
      box-sizing: border-box;
    }
    .streaming_modal {
      width: 460px;
      max-width: 100%;
      max-height: 85vh;
      border-radius: 10px;
      overflow: hidden;
      background: #202026;
      border: 1px solid #34343a;
      box-shadow: 0 24px 40px rgba(0, 0, 0, 0.42);
    }
    .streaming_modal.streaming_modal_wide {
      width: 760px;
    }
    .streaming_modal_head {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 14px 16px;
      border-bottom: 1px solid #33333a;
    }
    .streaming_modal_head h3 {
      font-size: 14px;
      color: #fff;
      margin: 0;
      font-weight: 500;
    }
    .streaming_modal_head button {
      border: 0;
      background: transparent;
      color: #c5c7cf;
      font-size: 12px;
      cursor: pointer;
      padding: 0;
    }
    .streaming_modal_body {
      padding: 14px 16px;
      max-height: calc(85vh - 53px);
      overflow-y: auto;
    }
    .streaming_modal_body ul {
      margin: 0;
      padding: 0;
      list-style: none;
    }
    .streaming_modal_body ul li {
      border-bottom: 1px solid #2f2f35;
      padding: 10px 0;
      display: flex;
      justify-content: space-between;
      gap: 10px;
    }
    .streaming_modal_body ul li:last-child {
      border-bottom: 0;
    }
    .streaming_modal_body ul li strong {
      font-size: 12px;
      color: #a0a0aa;
      flex-shrink: 0;
    }
    .streaming_modal_body ul li span {
      font-size: 12px;
      color: #fff;
      text-align: right;
      word-break: break-all;
    }
    .streaming_channel_table {
      width: 100%;
      border-collapse: collapse;
    }
    .streaming_channel_table th,
    .streaming_channel_table td {
      border-bottom: 1px solid #2f2f35;
      padding: 8px 6px;
      font-size: 11px;
      text-align: left;
      color: #fff;
      vertical-align: middle;
    }
    .streaming_channel_table th {
      color: #8b8b90;
      font-weight: 500;
    }
    
    .exit_content{
      padding:10px;
      border-radius: 0;
      background-color: #33343d;
    }
    .exit_content ul li{display:flex; align-items:center; justify-content:space-between;}
    .exit_content ul li div{height:18px;}
    .exit_content ul li h5{
      font-size: 12px;
      font-weight: 500;
      text-align: left;
      color: #5e5e61;
    }
    /*===========right_console=============*/
    .admin_console_top {
      display: flex;
      justify-content: left;
      align-items: center;
      background: #3b3b3f;
    }
    .admin_console_top h2 {
      font-size: 15px;
      color: #fff;
      margin: 0 auto;
    }
    .admin_console_top button {
      width: 50px;
      height: 50px;
    }
    .right_console button {
      width: 50px;
      height: 50px;
      transform: rotate(180deg);
      transition: all 0.3s;
    }
    .right_console.on button {
      transform: rotate(0deg);
    }
    .right_console_content {
      padding: 20px 20px 10px 20px;
    }
    .right_console_content p {
      font-size: 15px;
      color: #fff;
      font-weight: normal;
      margin-bottom: 5px;
    }
    .right_console_content span {
      font-size: 40px;
      font-weight: 900;
      color: #9898fc;
      line-height: 1.6;
      cursor:pointer;
      text-decoration:underline;
    }
    .right_console .right_console_folding {
      display: none;
    }
    .right_console.on {
      width: 50px;
      height: 220px;
      padding: 0;
    }
    .right_console.on .right_console_folding {
      display: block;
      inline-size: inherit;
      box-sizing: border-box;
      font-size:0;
    }
    .right_console .right_console_folding button {
      position: relative;
      height: 220px;
      z-index: 999999;
    }
    .right_console .right_console_folding button .arrow_div{
      position: absolute;
      top: 0;
      left: 50%;
      width: 50px;
      height: 50px;
      transform: translateX(-50%);
    }
    .right_console .right_console_folding button .number_div{
      position:relative;
      height: calc(100% - 50px);
      margin-top: 50px;
    }
    .right_console .right_console_folding button img {
      position: absolute;
      top: 15px;
      left: 50%;
      transform: translate(-50%);
    }
    .right_console.on .right_console_folding h2 {
      font-size: 15px;
      font-weight: 900;
      display: inline-block;
      color: #fff;
      position: absolute;
      bottom: 35%;
      left: 0;
      width: 50px;
      transform: rotate(-90deg);
      white-space: nowrap;
    }
    .right_console.on .right_console_folding span {
      font-size: 16px;
      display: inline-block;
      font-weight: 900;
      text-align: left;
      color: #9898fc;
      transform: rotate(-90deg);
      width: 46px;
      position: absolute;
      top: 14%;
      left: 0;
      text-align:center;
    }
    .right_console.on .admin_console_top,
    .right_console.on .right_console_content {
      display: none;
    }
    .right_console.on .admin_console_top h2 {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%) rotate(180deg);
      writing-mode: vertical-lr;
    }
`

export default CommonStyle;
